var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 99,
    viewBox: "0 0 130 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9577 89.5879C38.8629 92.346 39.7211 96.1527 39.7211 96.1527C33.1301 97.8222 26.4453 97.3013 26.4453 97.3013C26.6398 95.585 27.8802 94.63 27.8802 94.63C30.1733 93.8687 33.7537 90.7299 33.8476 89.6347C33.9817 88.0386 27.3371 77.8943 35.7719 72.6251C36.3821 72.2444 38.4069 71.6902 39.178 71.3629L41.632 72.171C40.4922 72.8054 39.5468 73.4799 38.769 74.1745C32.4462 79.8176 37.133 87.0435 37.9577 89.5946V89.5879Z",
    fill: "url(#paint0_linear_627_2408)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.728 96.1527C33.137 97.8222 26.4521 97.2947 26.4521 97.2947C26.6399 95.585 27.887 94.63 27.887 94.63C30.1801 93.8687 33.7605 90.7299 33.8544 89.6347C33.9416 88.653 32.1178 86.2688 31.568 81.5206C31.568 81.5206 34.1628 81.9814 35.5508 81.8879C36.0536 85.3405 37.5757 88.3925 37.9646 89.5879C38.8697 92.346 39.728 96.1527 39.728 96.1527Z",
    fill: "url(#paint1_linear_627_2408)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.728 96.1526V97.3748C39.728 97.3748 33.9282 99.0443 26.4521 97.869V97.3013C26.4521 97.3013 33.4655 97.7287 39.728 96.1593V96.1526Z",
    fill: "url(#paint2_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8799 94.63C27.8799 94.63 32.6203 94.5498 35.7716 92.1924L33.8473 89.6346C33.8473 89.6346 32.4728 92.6933 27.8799 94.63Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.639 72.171C40.4992 72.8054 39.5538 73.4799 38.776 74.1745C38.3871 73.0058 36.5566 72.2778 36.5566 72.2778C37.1668 71.8972 37.9312 71.3629 39.185 71.3629L41.639 72.171Z",
    fill: "#5E364C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6533 34.559C19.3046 35.721 18.661 36.6626 17.7424 37.2904C17.2999 37.5909 16.8104 37.8046 16.2807 37.9248C16.1667 37.9582 16.0527 37.9849 15.9321 37.9983C12.479 38.606 7.70508 35.8078 4.3459 30.8993C0.349747 25.0692 -0.139715 18.471 3.2597 16.1537C3.43403 16.0401 3.60835 15.94 3.79609 15.8465C5.35835 15.0785 7.34972 15.2321 9.42155 16.1537C11.9426 17.2623 14.571 19.4928 16.6495 22.5381C17.1121 23.2059 17.5211 23.8871 17.8832 24.5683C19.841 28.2146 20.4579 31.9278 19.6533 34.5456V34.559Z",
    fill: "url(#paint3_linear_627_2408)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38086 16.1136C3.38086 16.1136 6.64617 14.0634 9.05325 13.8831L22.2754 33.2167C22.2754 33.2167 20.0024 36.2152 17.4076 37.5241L3.38086 16.1136Z",
    fill: "url(#paint4_linear_627_2408)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4233 33.9994C24.5153 31.897 24.0125 25.802 20.3004 20.3859C16.5882 14.9698 11.0724 12.2835 7.98038 14.3859C4.88839 16.4883 5.39114 22.5832 9.1033 27.9994C12.8155 33.4155 18.3313 36.1018 21.4233 33.9994Z",
    fill: "url(#paint5_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16058 23.1659L6.00156 20.0271C6.00156 20.0271 5.53221 17.3958 7.15481 15.1453L1.89142 17.6496C1.89142 17.6496 0.557135 19.8334 1.16058 23.1659Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96131 18.5045C5.96131 18.5045 6.7592 16.5077 6.73238 15.8265C6.73238 15.8265 5.37798 16.9417 5.96131 18.5045Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0487 37.818L16.9912 34.4054C16.9912 34.4054 18.2383 34.8729 19.7469 34.6458L16.2738 37.9315C16.2738 37.9315 14.4433 38.2788 13.042 37.818H13.0487Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3673 36.2619C23.7303 37.0834 22.9391 37.7178 22.0138 38.1319C20.2839 38.8932 18.306 38.773 16.2878 37.9315C15.9257 37.7779 15.5502 37.6043 15.1815 37.4039C11.7619 35.5407 8.36923 31.694 6.12307 26.6653C4.44683 22.9054 3.68917 19.1121 3.80316 15.8598C3.93055 11.7326 5.44587 8.46697 8.22172 7.23817C9.34816 6.74398 10.5819 6.61709 11.8625 6.82412C16.1269 7.51866 20.9142 11.8662 23.8778 18.1905C23.9582 18.3575 24.0387 18.5311 24.1125 18.6981C27.2102 25.6368 27.1632 32.6891 24.3673 36.2553V36.2619Z",
    fill: "url(#paint6_linear_627_2408)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38965 7.19813C8.38965 7.19813 12.5199 5.04105 15.0946 5.22804L26.9959 35.7878C26.9959 35.7878 25.2057 37.257 21.5179 38.3456L8.38965 7.19813Z",
    fill: "url(#paint7_linear_627_2408)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9955 35.7878C26.1708 36.1484 25.2858 36.302 24.3672 36.262C22.8586 36.1952 21.2427 35.5941 19.6603 34.559C18.5473 33.8444 17.4544 32.9095 16.4017 31.7942C14.5914 29.8642 12.9486 27.3932 11.668 24.5349C10.3873 21.6699 9.6498 18.7916 9.42184 16.1604C9.07988 12.1667 9.92471 8.73411 11.8624 6.81745C12.3519 6.32326 12.9151 5.92924 13.5521 5.64875C18.2992 3.5451 25.1651 8.58719 28.8796 16.9083C28.9198 16.9885 28.9534 17.082 28.9869 17.1621C32.5673 25.4031 31.7024 33.6975 26.9955 35.7811V35.7878Z",
    fill: "url(#paint8_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82324 15.2187L9.42188 12.868C9.42188 12.868 9.44199 9.16154 12.2245 6.49023L5.9353 9.0213C5.9353 9.0213 4.07803 10.7577 3.82324 15.2187Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7572 10.7777C9.7572 10.7777 11.353 8.2466 11.4804 7.31165C11.4804 7.31165 9.3482 8.50038 9.7572 10.7777Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0332 37.818L20.8474 35.2469C20.8474 35.2469 22.4364 36.1952 24.5552 36.262L19.1577 38.6194C19.1577 38.6194 17.8301 38.793 16.0399 37.8113L16.0332 37.818Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9948 35.7878C26.1701 36.1484 25.2851 36.302 24.3665 36.2619C23.7295 37.0834 22.9383 37.7178 22.0131 38.1319C20.2832 38.8932 18.3052 38.773 16.287 37.9315C16.1731 37.9649 16.0591 37.9916 15.9384 38.005L15.1807 37.3972L12.834 35.514L16.401 31.7942L17.8828 24.5816L19.0025 19.1589L23.8703 18.1905L28.9795 17.1688C32.56 25.4098 31.695 33.7042 26.9881 35.7878H26.9948Z",
    fill: "#92364C"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.739 19.4861L104.833 23.1325C104.833 23.1325 100.126 21.4495 92.9321 19.4728C92.9321 19.4728 92.912 19.4728 92.9053 19.4728C82.3986 16.5811 66.6218 13.0683 52.5347 13.2753C33.1038 13.5558 20.1833 22.0105 20.1833 22.0105C20.1833 22.0105 17.1527 19.8735 20.009 18.264C20.009 18.264 24.8165 14.7646 33.7407 12.307C33.7542 12.307 33.7743 12.307 33.7877 12.2936C38.6085 10.9647 44.6363 10.0297 51.7502 9.92284C64.1745 9.72917 74.2185 11.4255 83.1697 13.2553C87.957 14.237 92.1811 15.2989 95.6409 16.2739C101.957 18.0436 105.725 19.4928 105.725 19.4928L105.739 19.4861Z",
    fill: "url(#paint9_linear_627_2408)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5861 54.8342C40.5861 54.8342 40.4989 59.2285 38.4941 59.4957C36.4893 59.7628 29.362 45.9788 25.4463 19.4193L28.4367 19.1055C28.4367 19.1055 30.884 40.0552 38.5411 53.4652C38.5411 53.4652 40.0296 52.1095 40.5861 54.8342Z",
    fill: "url(#paint10_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8554 15.7329L95.6543 16.2672L94.3334 19.8133C94.3334 19.8133 93.8439 19.6864 92.9321 19.466C92.9321 19.466 92.912 19.466 92.9053 19.466C82.3986 16.5744 66.6218 13.0616 52.5347 13.2686C33.1038 13.5491 20.1833 22.0038 20.1833 22.0038C20.1833 22.0038 17.1527 19.8667 20.009 18.2573C20.009 18.2573 24.8165 14.7579 33.7407 12.3003C33.7542 12.3003 33.7743 12.3003 33.7877 12.2869C33.7877 12.2869 34.2436 13.9565 36.2015 13.8162C38.166 13.6693 45.4744 11.9196 56.5644 12.2201C67.7282 12.5206 80.9503 15.3656 81.6677 15.3656C82.707 15.3656 84.1754 13.4489 84.1754 13.4489L95.8487 15.7396L95.8554 15.7329Z",
    fill: "url(#paint11_linear_627_2408)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2682 12.0932C29.2682 12.0932 30.6829 14.631 30.16 16.6478C30.16 16.6478 29.637 17.1086 28.363 17.0619L27.8669 16.2405C27.8669 16.2405 28.1686 17.5627 28.1686 18.1571C28.1686 18.1571 28.0948 18.7982 25.9962 18.7782L25.2452 17.683V18.4309C25.2452 18.4309 24.7692 18.9318 23.2002 18.7782C23.2002 18.7782 22.6236 17.9568 22.2481 17.2823C22.2481 17.2823 21.6246 17.6295 21.001 17.683C21.001 17.683 19.8544 16.561 19.4521 14.9983C19.4521 14.9983 19.9483 14.3772 21.3027 14.1769L21.5508 14.424L23.8975 14.05L24.1456 14.2503L24.1925 13.8897L26.7136 13.4022L27.0556 13.5959L26.8812 12.8679C26.8812 12.8679 27.4377 11.4388 29.2615 12.0866L29.2682 12.0932Z",
    fill: "url(#paint12_linear_627_2408)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8816 12.8679C26.8816 12.8679 27.9343 14.6978 28.3634 17.0552L27.8672 16.2338L26.7207 13.3955L27.0224 13.4957L26.8883 12.8613L26.8816 12.8679Z",
    fill: "#FF7F85"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1923 13.8897C24.1923 13.8897 24.6885 15.4391 25.2383 17.683C25.2383 17.683 24.3667 14.6577 23.8906 14.05L24.1253 14.1836L24.1856 13.8964L24.1923 13.8897Z",
    fill: "#FF7F85"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5439 14.4239L22.2413 17.2822C22.2413 17.2822 21.8054 14.9181 21.8926 14.3638L21.5439 14.4173V14.4239Z",
    fill: "#FF7F85"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.946 23.1725C28.946 23.1725 32.7142 21.5898 33.0159 19.4861C33.3042 17.4693 33.083 13.9098 33.2774 11.8195C33.2774 11.8195 31.9096 11.4989 31.0379 12.3203C30.1596 13.1418 30.059 14.8648 30.582 17.0886C30.582 17.0886 28.242 16.9083 27.2698 19.0053C27.2698 19.0053 25.6338 19.1121 21.9326 20.9887C21.9326 20.9887 21.9728 22.5515 26.1165 23.66L28.946 23.1725Z",
    fill: "url(#paint13_linear_627_2408)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9393 20.9887L22.0131 21.2091C22.0131 21.2091 25.4527 20.2274 27.2765 19.0119L28.0073 17.9902L21.9326 20.9887H21.9393Z",
    fill: "#FF7F85"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4943 34.8795C31.4943 34.8795 30.8238 36.7428 28.772 36.6025C28.772 36.6025 26.6868 29.951 25.7012 23.5465L29.7912 22.6984C29.7912 22.6984 30.4416 31.0596 31.4943 34.8862V34.8795Z",
    fill: "url(#paint14_linear_627_2408)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1433 48.5566V48.5767C95.0437 56.3836 91.3694 65.8133 86.4681 69.9605C85.6702 70.6283 84.8455 71.1626 83.994 71.5299C83.994 71.5299 82.2641 72.2111 79.3877 72.9657C75.2775 74.0476 68.8206 75.2964 61.7402 74.9558C61.7402 74.9558 58.8772 74.1945 57.5362 72.772C57.5362 72.772 40.8208 73.0592 32.8888 71.5299C31.4808 71.2628 22.4023 62.1068 21.4837 46.1324C21.2624 42.2457 21.5239 37.9515 22.4961 33.2834C22.4961 33.2834 32.3457 21.8569 51.1531 20.0471C69.9605 18.2439 76.7861 21.2759 78.8244 21.9905C83.538 23.6333 92.2142 31.5671 95.56 38.606C96.606 40.7965 96.7334 44.4495 96.15 48.5566H96.1433Z",
    fill: "url(#paint15_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4465 34.6324C39.4465 34.6324 42.9063 40.6028 45.4944 41.6513C48.0825 42.6998 55.6859 42.5195 58.8171 40.0886C61.9416 37.6577 61.5058 31.7875 61.5058 31.7875C61.5058 31.7875 63.0949 33.4971 63.6246 34.6324C64.1543 35.761 58.6294 45.0238 55.0556 45.872C49.0346 47.3011 39.8689 42.9068 39.8689 42.9068L38.5078 40.0819L39.4532 34.6257L39.4465 34.6324Z",
    fill: "url(#paint16_linear_627_2408)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4946 35.14C38.4946 35.14 35.4841 41.0302 33.6134 43.361C31.736 45.6917 28.9669 44.7701 27.2504 43.6615C25.5339 42.5529 26.5195 36.3287 26.5195 36.3287C26.5195 36.3287 24.783 38.3456 24.7561 39.9818C24.7293 41.6179 26.6 47.5883 28.2159 47.9489C29.8251 48.3029 34.8337 45.8052 36.6373 43.6682C38.4342 41.5311 38.5013 35.1534 38.5013 35.1534L38.4946 35.14Z",
    fill: "url(#paint17_linear_627_2408)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5362 37.8914C29.5362 37.8914 29.7239 39.8148 31.5409 40.0886C33.358 40.3624 33.653 38.3188 33.653 38.3188C33.653 38.3188 34.0486 40.7631 33.5122 41.5578C32.9758 42.3525 29.9586 42.653 29.4088 42.1388C28.8657 41.6246 28.6377 38.7863 28.6377 38.7863L29.5362 37.8914Z",
    fill: "url(#paint18_linear_627_2408)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.079 29.0227C65.079 29.0227 71.7437 34.559 76.6115 33.9913C81.4793 33.4237 82.827 30.5654 82.827 30.5654L81.4122 27.8073C81.4122 27.8073 84.9927 31.1931 85.3145 32.1682C85.6364 33.1432 80.326 37.651 77.9324 37.6777C75.5387 37.7045 67.3721 34.3987 65.0723 29.0227H65.079Z",
    fill: "url(#paint19_linear_627_2408)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6849 23.3061C42.6849 23.3061 44.0594 24.4614 48.7461 23.0389C53.4329 21.6098 54.0028 19.8066 54.0028 19.8066L57.2748 19.613C57.2748 19.613 47.2442 26.2111 40.7203 26.9658C40.7203 26.9658 36.7443 27.2529 34.4512 25.3964C34.4512 25.3964 37.7835 25.7169 39.1782 25.0023C40.5728 24.2878 40.8946 23.2994 40.8946 23.2994L42.6781 23.3127L42.6849 23.3061Z",
    fill: "url(#paint20_linear_627_2408)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5604 32.7024C46.5604 32.7024 48.5518 34.6524 50.6035 34.6324C52.6552 34.6057 53.1849 32.8026 53.1849 32.8026L53.9962 35.1466C53.9962 35.1466 51.1801 37.6777 50.1006 37.6777C49.0211 37.6777 46.5537 32.7091 46.5537 32.7091L46.5604 32.7024Z",
    fill: "url(#paint21_linear_627_2408)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4882 20.9219L41.3579 24.428C41.3579 24.428 38.7162 34.7059 38.7095 44.5029C38.7028 54.3066 40.6405 64.8984 40.6405 64.8984C40.6405 64.8984 37.7842 54.0395 37.7842 43.3342C37.7842 32.6289 40.6405 23.8537 40.6405 23.8537V22.2175L45.4882 20.9219Z",
    fill: "#FF7F85"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.494 42.9068C38.494 42.9068 41.1894 44.3627 42.1817 44.8702C44.0055 45.7985 52.7957 46.9739 55.1357 46.5465C57.4757 46.1191 64.4958 36.4623 64.4958 34.6324C64.4958 32.8026 58.9374 24.989 55.6855 24.9957C54.2842 24.9957 47.1836 30.0845 46.5534 31.6539C45.9164 33.2233 49.403 38.1252 49.9327 38.2654C50.4556 38.4056 53.8014 36.1016 53.8014 36.1016L55.9001 36.9832L53.1779 32.7959L53.4662 35.4605C53.4662 35.4605 51.3407 37.1835 50.3148 37.4106C49.289 37.6376 46.5534 33.2367 47.016 31.881C47.4786 30.5253 53.6807 26.2445 55.9336 26.4582C58.1932 26.6719 62.8464 32.9495 62.8866 34.953C62.9202 36.9498 57.6568 45.4111 55.0418 45.872C51.4748 46.5064 43.7574 44.5497 42.3963 43.4077C41.0352 42.2657 38.8829 38.626 38.8829 38.626L38.4873 42.9068H38.494Z",
    fill: "#FF7F85"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4948 42.5862C38.4948 42.5862 37.7774 43.3342 36.128 44.6432C34.5724 45.8786 29.356 48.61 27.7669 48.3696C26.1778 48.1292 23.6568 41.4443 24.1395 38.9733C24.6156 36.5023 29.3694 30.7991 31.3742 31.0863C33.3789 31.3734 34.6462 40.6963 33.9287 41.9318C33.2113 43.1673 29.6778 42.5529 29.2487 42.3124C28.8196 42.072 28.2094 39.2671 28.2094 39.2671L27.0025 38.98L29.537 37.8847L28.8196 39.2671C28.8196 39.2671 29.2621 41.4977 29.6778 42.0119C30.0935 42.5261 33.0571 41.9385 33.6069 40.9434C34.1567 39.9483 33.2113 33.3101 31.2803 32.6623C29.3493 32.0212 25.1721 37.5441 24.9441 39.374C24.7228 41.1972 27.0159 47.4881 28.7056 47.7218C30.4019 47.9623 34.1902 45.7384 35.5849 44.2959C36.9795 42.8534 38.126 36.5758 38.126 36.5758L38.4814 42.5796L38.4948 42.5862Z",
    fill: "#FF7F85"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.412 25.2361C33.412 25.2361 36.9589 27.3331 39.5872 27.8072L40.6332 27.6336C40.6332 27.6336 54.1705 22.7451 58.9377 19.4794L56.0345 19.6664C56.0345 19.6664 52.7893 22.7251 46.0106 25.2561C41.6792 26.879 40.6332 25.8171 40.6332 25.8171L39.956 25.9974C39.956 25.9974 39.1648 26.9257 37.1265 26.5317C35.0815 26.1377 34.525 24.6751 34.525 24.6751L33.4053 25.2428L33.412 25.2361Z",
    fill: "#FF7F85"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3665 20.4277C73.3665 20.4277 65.3877 21.8168 64.0735 23.6467C62.766 25.4765 65.8436 35.4672 77.9729 37.0833C77.9729 37.0833 83.2765 35.4405 84.1347 31.7942C84.1347 31.7942 82.0562 27.2863 76.3234 25.0023C76.3234 25.0023 73.4604 24.6484 71.4489 26.4315C71.4489 26.4315 73.1453 30.1446 75.7267 31.3801L77.9729 31.1931L74.5801 33.0029L74.8685 31.8008C74.8685 31.8008 72.0054 29.43 70.5706 26.5784C70.5706 26.5784 72.9575 24.5349 76.6855 24.3879C76.6855 24.3879 83.1826 27.6737 86.1462 32.3351C86.1462 32.3351 83.2832 37.8513 77.832 38.3322C77.832 38.3322 63.8388 35.7677 62.7861 23.66C62.7861 23.66 64.7037 21.73 68.1903 20.6815V19.7399C68.1903 19.7399 71.7708 20.0938 73.3665 20.4411V20.4277Z",
    fill: "#FF7F85"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4773 40.8766C21.4773 40.8766 22.9457 51.5886 24.0922 53.9193C25.2388 56.25 27.7129 57.2851 27.7129 57.2851C27.7129 57.2851 28.6784 52.3232 32.9964 52.3966C37.3479 52.4701 39.4398 56.4103 39.4398 56.4103C39.4398 56.4103 39.8287 56.2032 43.9389 53.9126C48.2099 51.5418 51.2607 48.4297 56.799 48.7169C62.3373 49.0041 63.2961 52.2964 63.6112 52.1095C63.9263 51.9225 66.6754 43.7349 68.9752 42.3058C71.2817 40.8766 78.1341 39.9016 80.6753 40.8699C83.2165 41.8316 81.5738 54.1664 80.6753 55.7558C79.7768 57.3452 71.6571 56.831 71.0872 55.7558C70.5173 54.6806 71.0872 48.176 72.5221 47.241C73.9569 46.306 76.297 45.9721 76.297 45.9721L76.8669 43.8284V49.2378L76.0087 46.6333C76.0087 46.6333 73.2395 47.5549 72.6629 48.383C72.093 49.2111 71.0872 53.7523 71.7577 55.0613C72.4282 56.3702 78.818 56.0563 80.0182 54.9678C81.2251 53.8792 80.9234 45.2575 80.4004 43.3542C79.8774 41.4509 71.2481 41.3775 69.2232 42.9001C67.1983 44.4228 65.2606 53.5787 65.0192 53.9126C64.7779 54.2465 62.4512 54.2198 62.4512 54.2198C62.4512 54.2198 58.1601 51.0476 53.1716 51.8223C48.1831 52.597 41.619 56.0096 41.619 56.0096L39.3661 59.0749C39.3661 59.0749 36.892 53.8725 33.3048 54.2532C29.7177 54.6338 29.2416 58.18 29.2416 58.18L29.5903 60.1234C29.5903 60.1234 26.8949 58.6341 24.5817 55.4887C22.2685 52.3432 21.4639 47.241 21.4639 47.241V40.8699L21.4773 40.8766Z",
    fill: "#FF7F85"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.293 72.5783C59.293 72.5783 64.2211 64.2505 67.2316 63.536C70.2422 62.8214 73.1789 65.466 73.8226 66.7482C74.4663 68.0304 73.3667 70.1942 73.3667 70.1942L71.1406 70.7819C71.1406 70.7819 73.4672 68.4445 73.3667 67.1957C73.2661 65.9535 70.2891 64.2372 67.3724 64.8783C64.4558 65.5194 62.5583 71.2894 62.5583 71.2894L63.6177 72.0641C63.6177 72.0641 60.0037 72.8188 59.293 72.5783Z",
    fill: "#FF7F85"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.521 55.7625C94.521 55.7625 90.7998 60.464 88.795 60.8246C86.7902 61.1786 83.706 60.6176 83.4244 60.1301C83.136 59.6359 82.1571 51.455 83.592 44.0355C85.0268 36.6159 88.9626 33.7843 90.0153 33.2834C91.068 32.7826 94.6753 39.0668 94.9569 44.2759C95.2452 49.4849 90.1092 54.6005 89.1034 55.0746C88.0977 55.5488 86.046 50.4533 86.4751 46.6467C86.9042 42.8467 88.8621 39.6078 90.0556 39.5143C91.249 39.4208 91.9195 44.0822 91.3898 46.2727C91.3898 46.2727 91.0345 40.4292 89.8611 40.496C88.6877 40.5628 86.9176 45.0439 86.9444 48.3162C86.9713 51.5886 88.7749 53.572 89.7605 53.5988C90.7462 53.6255 95.0105 48.3029 94.3467 43.8485C93.6829 39.3941 91.4569 36.1618 90.1427 35.8279C88.8285 35.494 84.8793 39.1336 83.9809 45.7518C83.0824 52.3633 84.7452 59.469 85.5096 60.1368C86.274 60.8046 88.4531 60.484 90.8601 58.4138C93.2672 56.3435 96.1369 48.5633 96.1369 48.5633C96.1369 48.5633 95.5402 52.764 94.5076 55.7759L94.521 55.7625Z",
    fill: "#FF7F85"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1439 48.5567V48.5767C95.0443 56.3836 91.37 65.8133 86.4686 69.9605L79.3815 72.9657C75.2714 74.0476 68.8145 75.2965 61.7341 74.9559C61.7341 74.9559 58.8711 74.1946 57.5301 72.7721C57.5301 72.7721 40.8146 73.0592 32.8827 71.5299C31.4746 71.2628 22.3961 62.1069 21.4775 46.1324C21.4775 46.1324 22.9459 51.5352 25.7419 53.345C25.7419 53.345 28.3233 51.1879 32.2591 50.9408C36.1949 50.687 38.6087 52.8909 38.6087 52.8909C38.6087 52.8909 40.1106 51.9559 44.2677 50.313C48.418 48.6702 51.9314 47.4347 56.5713 47.4881C61.2044 47.5482 63.8998 51.5485 63.8998 51.5485L66.6488 47.4881C66.6488 47.4881 66.7963 49.2512 68.9687 50.0259C71.1478 50.7939 71.872 49.5718 71.872 49.5718C71.872 49.692 71.8988 52.0494 74.0041 52.8975C76.1698 53.7724 81.8489 50.6603 81.9361 48.3964C81.9361 48.3964 82.0031 50.0726 82.8614 50.313C83.7263 50.5535 86.9715 47.4614 86.9715 47.4614C86.9715 47.4614 90.6458 49.9257 93.4284 48.9106L96.1238 48.5567H96.1439Z",
    fill: "url(#paint22_linear_627_2408)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2812 61.7462C29.2812 61.7462 30.4546 66.4678 33.8004 66.1739C37.4479 65.8534 37.763 59.676 37.763 59.676L29.2812 61.7462Z",
    fill: "#E16070"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5604 58.5941C46.5604 58.5941 47.8411 66.4678 55.1159 66.1739C62.0019 65.8935 62.4847 58.0064 62.4847 58.0064L46.5537 58.6008L46.5604 58.5941Z",
    fill: "#E16070"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1314 54.8877C46.1314 54.8877 45.7157 61.3188 50.4293 63.8699C54.9082 66.2941 60.2588 63.9634 61.6936 61.0116C63.1285 58.0598 62.4714 54.2265 62.4714 54.2265C62.4714 54.2265 55.1697 48.4164 46.1381 54.8877H46.1314Z",
    fill: "url(#paint23_linear_627_2408)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6072 58.4004C60.6072 60.6176 58.8036 62.4141 56.5775 62.4141C54.3515 62.4141 52.5479 60.6176 52.5479 58.4004C52.5479 56.1832 54.3515 54.3868 56.5775 54.3868C58.8036 54.3868 60.6072 56.1832 60.6072 58.4004Z",
    fill: "#37193E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4526 58.18C46.4526 58.18 51.032 56.3969 56.1211 56.5372C61.2102 56.6774 62.4573 58.3937 62.4573 58.3937C62.4573 58.3937 62.6718 55.689 62.4573 54.2198C62.4573 54.2198 60.533 51.5352 54.7399 51.5352C48.9468 51.5352 46.124 54.8743 46.124 54.8743C46.124 54.8743 46.124 57.0381 46.4459 58.1667L46.4526 58.18Z",
    fill: "#D8CBD9"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4365 58.1667C28.4365 58.1667 29.0534 65.4927 33.4921 65.1321C37.9307 64.7648 38.3129 58.1666 37.7631 55.6957C37.7631 55.6957 35.765 53.1112 32.493 53.5586C29.221 54.0061 28.4365 58.1667 28.4365 58.1667Z",
    fill: "url(#paint24_linear_627_2408)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2206 60.3838C37.1535 62.4408 35.8997 64.0703 34.4179 64.0168C32.9428 63.9701 31.803 62.2604 31.87 60.2035C31.937 58.1466 33.1909 56.5171 34.6727 56.5706C36.1478 56.6173 37.2876 58.3269 37.2206 60.3838Z",
    fill: "#37193E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4365 58.1667L28.8187 60.2903C28.8187 60.2903 30.6827 57.7058 33.9614 57.3853C37.1127 57.0714 37.9173 58.8412 37.9173 58.8412C37.9173 58.8412 38.1185 57.0514 37.7631 55.6957C37.7631 55.6957 36.1942 53.4184 33.197 53.5119C30.1999 53.6054 28.4365 58.1667 28.4365 58.1667Z",
    fill: "#D8CBD9"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5293 72.7653C57.5293 72.7653 66.4402 71.8838 71.9584 70.6016C77.4765 69.3194 84.0675 63.8899 84.0675 63.8899C84.0675 63.8899 89.5656 61.5258 91.7246 62.7813C91.7246 62.7813 88.8213 69.2459 84.6173 71.9573C80.4133 74.6687 64.3281 75.4901 61.3578 75.0092C58.9507 74.6219 57.536 72.7653 57.536 72.7653H57.5293Z",
    fill: "url(#paint25_linear_627_2408)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5908 44.3026C35.5908 44.3026 38.0381 43.4812 38.4941 42.9135L41.4308 44.4829C41.4308 44.4829 40.2239 40.7497 38.5142 38.9733C38.5142 38.9733 36.4692 43.8151 35.5975 44.3026H35.5908Z",
    fill: "#E16070"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2157 39.2671L27.0088 38.9867L29.5366 37.8914L28.8258 39.2671L28.9666 39.935L28.2157 39.2671Z",
    fill: "#E16070"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0088 45.9855C27.0088 45.9855 27.8871 47.6083 28.8124 47.7419C29.7377 47.8754 31.4676 47.0473 31.4676 47.0473C31.4676 47.0473 29.3756 48.5032 28.2425 48.3763C27.1094 48.2561 27.0088 45.9855 27.0088 45.9855Z",
    fill: "#E16070"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0723 45.8453C51.0723 45.8453 54.0493 46.3996 55.4841 45.7317C56.4161 45.2977 58.8098 43.027 58.8098 43.027C58.8098 43.027 56.7916 46.079 55.1422 46.5532C53.4928 47.0273 51.0723 45.8453 51.0723 45.8453Z",
    fill: "#E16070"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6708 53.6121L39.3729 55.7625L43.1075 54.3867L41.6324 56.0162L39.6813 58.4872C39.6813 58.4872 37.1334 55.2883 36.6641 53.6121H36.6708Z",
    fill: "#E16070"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2969 57.973C27.2969 57.973 27.4042 52.8107 31.0584 51.829C34.7126 50.8473 37.7566 54.3868 37.7566 54.3868V55.6957C37.7566 55.6957 35.4836 53.0711 32.4865 53.5587C29.4894 54.0462 27.2969 57.9663 27.2969 57.9663V57.973Z",
    fill: "#E16070"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1182 53.9727C46.1182 53.9727 48.2637 50.0793 53.9965 48.7103C57.0606 47.9823 61.5664 49.2245 63.6181 52.1162V54.1063C63.6181 54.1063 60.8154 50.6536 54.3653 51.3482C47.9151 52.0427 46.1182 53.9727 46.1182 53.9727Z",
    fill: "#E16070"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.876 55.068C45.876 55.068 49.1547 50.0259 55.8395 50.0259C61.3778 50.0259 63.6173 54.1063 63.6173 54.1063L62.464 54.2265C62.464 54.2265 59.6614 51.829 55.2897 51.829C49.6509 51.829 45.8827 55.068 45.8827 55.068H45.876Z",
    fill: "#4B3052"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.763 55.6957C37.763 55.6957 35.4163 52.1362 32.2314 52.6905C28.6108 53.3249 27.0083 56.4437 27.2966 57.973L28.4297 58.1667C28.4297 58.1667 30.1529 54.1197 32.8751 53.8726C35.5973 53.6255 37.7563 55.6957 37.7563 55.6957H37.763Z",
    fill: "#4B3052"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5834 52.8908C71.5834 52.8908 71.4359 54.921 72.0997 55.4152C72.7635 55.9161 75.9349 55.9829 75.9349 55.9829C75.9349 55.9829 72.6361 56.7509 71.57 56.1031C70.5039 55.4486 71.5834 52.8842 71.5834 52.8842V52.8908Z",
    fill: "#E16070"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0518 35.8212C73.0518 35.8212 76.9406 37.1101 77.9799 37.0833C79.0192 37.0566 82.0498 34.8795 82.0498 34.8795C82.0498 34.8795 81.205 37.7245 77.8391 38.3188C77.8391 38.3188 75.4722 37.9716 73.0585 35.8212H73.0518Z",
    fill: "#E16070"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5869 32.9896L74.8685 31.7875L75.2105 31.0796L75.7335 31.3734L77.9729 31.1798L74.5869 32.9896Z",
    fill: "#E16070"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2026 32.9896C62.2026 32.9896 63.0542 34.0982 62.8932 34.953C62.7256 35.8011 61.9277 37.6777 61.9277 37.6777C61.9277 37.6777 64.0733 35.9881 64.1806 34.8795C64.2879 33.7709 62.2026 32.9896 62.2026 32.9896Z",
    fill: "#E16070"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1327 26.5317C37.1327 26.5317 39.399 27.5668 40.3041 27.4934C41.2093 27.4266 43.5493 25.9907 43.5493 25.9907C43.5493 25.9907 41.5378 26.2979 41.1422 26.2312C40.7466 26.1577 40.4785 25.57 40.4785 25.57C40.4785 25.57 39.9085 26.3046 39.2045 26.5384C38.5072 26.7654 37.126 26.5384 37.126 26.5384L37.1327 26.5317Z",
    fill: "#E16070"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1216 55.0679C84.1216 55.0679 84.5775 59.5023 85.5229 60.1301C86.4683 60.7578 88.0775 60.1301 88.0775 60.1301C88.0775 60.1301 87.1992 61.0984 83.8467 60.4106C83.8467 60.4106 83.4712 60.5642 83.2164 58.8879C82.9617 57.2117 84.1149 55.0746 84.1149 55.0746L84.1216 55.0679Z",
    fill: "#E16070"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0519 49.4515C87.0519 49.4515 87.0653 53.3516 89.7741 53.5921C89.7741 53.5921 90.4982 53.4385 91.3363 52.3299C91.3363 52.3299 91.0011 54.2599 89.1036 55.068C89.1036 55.068 86.7904 53.5386 87.0519 49.4515Z",
    fill: "#E16070"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0791 64.8984C65.0791 64.8984 66.2458 64.1972 68.9814 64.7448C71.717 65.2924 72.7429 66.1673 72.7429 66.1673C72.7429 66.1673 71.4287 63.7898 69.1892 63.4091C66.9431 63.0285 65.0858 64.8917 65.0858 64.8917L65.0791 64.8984Z",
    fill: "#E16070"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8682 28.6888C81.8682 28.6888 84.3021 31.2599 84.1411 31.7875C83.9802 32.3151 83.9735 32.9963 83.008 33.9379C83.008 33.9379 84.8921 33.3502 85.3212 32.1682C85.7503 30.9928 81.8682 28.6888 81.8682 28.6888Z",
    fill: "#E16070"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5448 41.2172C90.5448 41.2172 91.564 43.9152 91.3963 46.266C91.3963 46.266 91.698 44.2158 91.4969 42.9269C91.2958 41.638 90.5381 41.2172 90.5381 41.2172H90.5448Z",
    fill: "#E16070"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5132 60.7245C32.5132 61.0784 32.2249 61.3589 31.8762 61.3589C31.5276 61.3589 31.2393 61.0717 31.2393 60.7245C31.2393 60.3772 31.5276 60.09 31.8762 60.09C32.2249 60.09 32.5132 60.3772 32.5132 60.7245Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3185 58.9213C53.3185 59.3487 52.9698 59.6893 52.5474 59.6893C52.125 59.6893 51.7764 59.3421 51.7764 58.9213C51.7764 58.5006 52.125 58.1533 52.5474 58.1533C52.9698 58.1533 53.3185 58.5006 53.3185 58.9213Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5924 27.8073C47.5924 27.8073 46.1241 31.0863 44.5082 31.7875C44.5082 31.7875 43.3951 33.4571 43.2543 33.9379C43.1135 34.4187 44.9038 37.3305 46.9421 38.3189C48.9871 39.3072 51.0656 39.1603 51.0656 39.1603C51.0656 39.1603 55.0416 37.7913 57.6566 37.6711C57.6566 37.6711 56.4363 39.4408 54.1968 39.9417C51.9574 40.4425 51.3941 39.4074 51.0656 39.354C50.7371 39.3006 48.1221 39.9417 45.2256 38.9065C42.3223 37.8714 41.8932 35.2335 42.1078 34.3252C42.3224 33.417 43.8779 32.7091 44.3137 31.7875C44.7428 30.8659 44.24 30.6121 44.6892 29.4034C45.1384 28.1879 47.5924 27.8073 47.5924 27.8073Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0723 30.0912C51.0723 30.0912 53.419 27.6737 55.5713 27.8139C57.7236 27.9542 60.6671 31.8943 60.6067 33.25C60.6067 33.25 59.5138 32.3284 58.3471 31.0796C57.1738 29.8308 57.4219 28.9893 56.7447 28.4484C56.0675 27.9074 55.4305 27.9742 55.1422 28.1144C54.8539 28.2547 54.1632 29.8241 52.9899 29.9243C51.8165 30.0244 51.0723 30.0912 51.0723 30.0912Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6276 21.9971C74.6276 21.9971 67.6075 23.0456 66.5615 24.1876C65.5088 25.3296 67.8019 28.996 69.2837 29.5636C69.2837 29.5636 69.6659 28.3949 69.2569 27.3999C68.8479 26.4048 66.6554 25.8037 66.6084 24.9957C66.5615 24.1876 67.6142 23.2994 69.7397 23.2927C71.8651 23.286 74.413 23.246 74.6343 21.9971H74.6276Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5614 45.3577C59.5614 45.3577 62.9139 44.6899 64.1878 42.9068C65.4617 41.1237 65.1667 39.7413 66.2932 38.3188C67.4196 36.8897 71.7577 37.4173 73.0518 38.3188C73.0518 38.3188 73.1389 39.1403 71.8851 38.9733C70.6313 38.8064 70.0748 37.7378 68.8008 37.6777C67.5269 37.6176 66.5144 37.9716 66.2865 38.5593C66.0585 39.1469 66.9704 40.7698 66.615 42.446C66.2596 44.1223 64.57 43.6014 62.7798 44.8435C60.9895 46.0857 60.6007 46.1257 60.6007 46.1257C60.6007 46.1257 59.6955 46.2393 59.5547 45.3577H59.5614Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0195 29.0227C30.0195 29.0227 32.7082 28.0878 33.8011 28.4684C34.894 28.8491 36.1814 32.3685 36.1814 32.3685C36.1814 32.3685 36.4965 29.3967 35.2762 27.4934C34.0559 25.5901 30.0195 29.016 30.0195 29.016V29.0227Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1461 54.9744C86.1461 54.9744 84.8387 50.7938 84.6174 47.2477C84.3894 43.7015 86.0255 41.8717 86.3138 41.2172C86.6021 40.556 88.5331 37.5041 90.0149 37.4373C91.4967 37.3705 92.4287 40.1286 92.4287 40.1286C92.4287 40.1286 91.309 37.5041 90.1624 37.6777C89.0159 37.8513 88.7074 39.1069 88.2046 39.7213C87.7017 40.3423 86.4345 40.7898 85.7908 42.7933C85.1471 44.7901 86.2467 48.5232 86.3875 50.313C86.5283 52.0961 86.1461 54.9811 86.1461 54.9811V54.9744Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4198 51.0677C67.4198 51.0677 68.5529 46.5799 69.4715 44.4762C70.3901 42.3726 74.3192 41.9051 77.1487 42.6197C77.1487 42.6197 76.7531 43.4545 75.4993 43.7349C74.2454 44.0088 72.0931 43.2675 71.0941 43.4411C70.0951 43.6147 70.8527 45.5448 70.4571 47.7619C70.0548 49.9725 67.4131 51.0677 67.4131 51.0677H67.4198Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2344 50.3063C29.2344 50.3063 30.2066 48.1626 35.2219 48.3763C35.2219 48.3763 31.7487 50.3998 29.2344 50.3063Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.293 66.815C59.293 66.815 61.1435 61.6861 65.0793 61.3589C65.0793 61.3589 64.1809 65.5996 59.293 66.815Z",
    fill: "white"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2158 36.5959C28.2158 36.5959 29.2082 34.5122 30.4955 34.6324C31.7829 34.7527 32.2321 35.6142 32.2321 35.6142C32.2321 35.6142 28.7053 36.1618 28.2158 36.5959Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2001 64.7715C37.2001 64.7715 38.3935 71.6568 42.041 72.1509C45.6885 72.6518 47.8207 64.0903 47.8207 64.0903L37.1934 64.7715H37.2001Z",
    fill: "url(#paint26_linear_627_2408)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1777 21.9972C46.1777 21.9972 48.5982 23.0457 51.4948 20.9153C51.4948 20.9153 48.3233 20.2808 46.1777 21.9972Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0723 30.0912C51.0723 30.0912 52.7284 30.7056 53.7341 29.6505C54.7399 28.5953 54.941 27.8073 54.941 27.8073C54.941 27.8073 51.8299 28.4751 51.0723 30.0912Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0723 39.1603C51.0723 39.1603 55.5847 37.2904 57.6632 37.6711C57.6632 37.6711 57.1268 39.374 54.2035 39.9417C51.2868 40.5093 51.0723 39.1536 51.0723 39.1536V39.1603Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.748 23.6467C67.748 23.6467 69.6053 22.2376 74.6273 22.0038C74.6273 22.0038 74.6541 23.2861 72.8907 23.4998C71.1206 23.7135 67.748 23.6467 67.748 23.6467Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1875 42.9335C71.1875 42.9335 73.2861 43.8485 74.9691 43.8017C76.652 43.7483 77.1549 42.6263 77.1549 42.6263C77.1549 42.6263 74.0639 41.7715 71.1875 42.9335Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5342 39.3272C87.5342 39.3272 88.1712 37.3839 89.4853 37.2036C90.7995 37.0232 91.3359 38.1585 91.3359 38.1585C91.3359 38.1585 90.3368 37.8647 88.9355 38.5926L87.5342 39.3272Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9612 63.5226C47.9612 63.5226 47.6595 64.7381 47.0091 66.1606L46.9957 66.1873C46.0972 68.1574 44.5484 70.5014 42.2553 70.5014C40.8405 70.5014 39.8147 69.9071 39.0637 69.0923C37.4009 67.2692 37.126 64.3307 37.126 64.3307C37.126 64.3307 41.6317 64.2038 47.9612 63.5226Z",
    fill: "url(#paint27_linear_627_2408)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4221 19.4193C88.5065 45.9855 81.3791 59.7628 79.381 59.4956C77.3762 59.2285 77.2891 54.8342 77.2891 54.8342C77.8456 52.1161 79.3274 53.4718 79.3274 53.4718C86.9844 40.0619 89.4317 19.1121 89.4317 19.1121L92.4221 19.426V19.4193Z",
    fill: "url(#paint28_linear_627_2408)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6074 12.0932C88.6074 12.0932 87.1926 14.631 87.7156 16.6478C87.7156 16.6478 88.2386 17.1086 89.5125 17.0619L90.0087 16.2405C90.0087 16.2405 89.707 17.5627 89.707 18.1571C89.707 18.1571 89.7807 18.7982 91.8794 18.7782L92.6304 17.683V18.4309C92.6304 18.4309 93.1064 18.9318 94.6754 18.7782C94.6754 18.7782 95.252 17.9568 95.6275 17.2823C95.6275 17.2823 96.251 17.6295 96.8746 17.683C96.8746 17.683 98.0211 16.561 98.4234 14.9983C98.4234 14.9983 97.9273 14.3772 96.5729 14.1769L96.3248 14.424L93.978 14.05L93.73 14.2503L93.683 13.8897L91.162 13.4022L90.82 13.5959L90.9943 12.8679C90.9943 12.8679 90.4378 11.4388 88.6141 12.0866L88.6074 12.0932Z",
    fill: "url(#paint29_linear_627_2408)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9945 12.8679C90.9945 12.8679 89.9418 14.6978 89.5127 17.0552L90.0089 16.2338L91.1554 13.3955L90.8537 13.4957L90.9878 12.8613L90.9945 12.8679Z",
    fill: "#FF7F85"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6827 13.8897C93.6827 13.8897 93.1865 15.4391 92.6367 17.683C92.6367 17.683 93.5084 14.6577 93.9844 14.05L93.7497 14.1836L93.6894 13.8964L93.6827 13.8897Z",
    fill: "#FF7F85"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3311 14.4239L95.6338 17.2822C95.6338 17.2822 96.0696 14.9181 95.9824 14.3638L96.3311 14.4173V14.4239Z",
    fill: "#FF7F85"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9222 23.1725C88.9222 23.1725 85.154 21.5898 84.8523 19.4861C84.564 17.4693 84.7853 13.9098 84.5908 11.8195C84.5908 11.8195 85.9586 11.4989 86.8303 12.3203C87.7019 13.1418 87.8092 14.8648 87.2862 17.0886C87.2862 17.0886 89.6262 16.9083 90.5985 19.0053C90.5985 19.0053 93.0122 19.6063 96.1502 20.5213C96.1502 20.5213 95.9021 22.5515 91.7584 23.66L88.9289 23.1725H88.9222Z",
    fill: "url(#paint30_linear_627_2408)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1498 20.3743C96.1498 20.3743 96.1967 20.7617 95.8615 21.2091C95.8615 21.2091 92.4218 20.2274 90.5981 19.012L90.3701 18.5979L96.1498 20.3743Z",
    fill: "#FF7F85"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.374 34.8795C86.374 34.8795 87.0445 36.7428 89.0962 36.6025C89.0962 36.6025 91.1815 29.951 92.1671 23.5465L88.0771 22.6984C88.0771 22.6984 87.4267 31.0596 86.374 34.8862V34.8795Z",
    fill: "url(#paint31_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9612 63.5226C47.9612 63.5226 47.6595 64.7381 47.0091 66.1606L46.9957 66.1873C43.1336 66.2607 39.0905 69.1124 39.0905 69.1124L39.0637 69.0923C37.4009 67.2692 37.126 64.3307 37.126 64.3307C37.126 64.3307 41.6317 64.2038 47.9612 63.5226Z",
    fill: "#92364C"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M116.417 24.934C119.406 14.6184 116.958 4.85554 110.949 3.128C104.94 1.40045 97.6452 8.36242 94.6558 18.678C91.6665 28.9935 94.1145 38.7564 100.124 40.484C106.133 42.2115 113.427 35.2495 116.417 24.934Z",
    fill: "url(#paint32_linear_627_2408)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.123 3.21118C111.123 3.21118 116.36 4.35984 118.485 6.42343L106.242 42.0988C106.242 42.0988 103.573 42.072 99.5234 40.309L111.123 3.21118Z",
    fill: "url(#paint33_linear_627_2408)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M121.933 26.8759C124.849 16.812 122.556 7.31442 116.81 5.66256C111.064 4.01071 104.042 10.8301 101.125 20.894C98.209 30.958 100.503 40.4555 106.249 42.1074C111.994 43.7593 119.017 36.9399 121.933 26.8759Z",
    fill: "url(#paint34_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.139 6.90424L107.817 8.96114C107.817 8.96114 110.593 5.71551 115.025 5.41498L107.609 3.0108C107.609 3.0108 104.686 3.17108 101.139 6.91091V6.90424Z",
    fill: "white"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.661 7.37175C109.661 7.37175 112.947 6.32326 113.758 5.58865C113.758 5.58865 111.002 5.06107 109.661 7.37175Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.084 35.8011L101.226 37.0901C101.226 37.0901 101.923 39.0935 103.733 40.7164L97.2296 38.813C97.2296 38.813 95.9355 37.9849 95.084 35.8011Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.336 28.1546C117.754 37.0634 111.935 43.2141 107.328 41.8918C102.729 40.5695 101.086 32.275 103.667 23.3662C106.249 14.4574 112.069 8.30673 116.675 9.62902C121.275 10.9513 122.917 19.2457 120.336 28.1546Z",
    fill: "#5E364C"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M120.925 26.1577C123.187 18.3511 121.335 10.9628 116.789 9.65568C112.242 8.34851 106.722 13.6174 104.46 21.424C102.197 29.2307 104.049 36.6189 108.596 37.9261C113.143 39.2333 118.663 33.9644 120.925 26.1577Z",
    fill: "url(#paint35_linear_627_2408)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.909 9.72253C116.909 9.72253 121.126 11.1049 123.05 13.0951L115.534 38.9333C115.534 38.9333 111.203 39.1203 108.139 37.7913L116.915 9.72253H116.909Z",
    fill: "url(#paint36_linear_627_2408)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M125.512 27.7946C127.612 20.5478 125.96 13.7088 121.822 12.5193C117.685 11.3297 112.628 16.2401 110.528 23.4869C108.428 30.7336 110.08 37.5726 114.218 38.7621C118.355 39.9517 123.412 35.0413 125.512 27.7946Z",
    fill: "url(#paint37_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.004 12.9281L115.347 14.8982C115.347 14.8982 117.345 12.5608 120.536 12.3404L114.448 9.52887C114.448 9.52887 111.525 9.9496 109.004 12.9281Z",
    fill: "white"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.675 13.7495C116.675 13.7495 119.042 12.9949 119.625 12.4673C119.625 12.4673 117.64 12.0866 116.675 13.7495Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.68 34.165L110.607 35.1467C110.607 35.1467 111.11 36.5892 112.41 37.7579L106.946 37.0967C106.946 37.0967 105.297 35.7344 104.68 34.165Z",
    fill: "white"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.295 22.8987L118.706 22.5447C118.706 22.5447 117.285 22.6449 116.581 25.3363C115.957 27.7137 116.929 28.9692 116.929 28.9692L118.425 29.3633L120.295 22.8987Z",
    fill: "url(#paint38_linear_627_2408)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.207 26.6586C120.691 28.4417 119.444 29.6504 118.424 29.3566C117.405 29.0627 116.996 27.3798 117.512 25.5967C118.029 23.8136 119.276 22.6048 120.295 22.8987C121.314 23.1925 121.723 24.8755 121.207 26.6586Z",
    fill: "url(#paint39_linear_627_2408)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2812 61.7462C29.2812 61.7462 33.1299 63.4291 37.4412 61.3655C37.4412 61.3655 37.0255 65.4326 33.0159 65.4326C30.1261 65.4326 29.2812 61.7529 29.2812 61.7529V61.7462Z",
    fill: "#E16070"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8018 59.3888C46.8018 59.3888 53.3592 61.6861 62.2433 59.3888C62.2433 59.3888 61.3783 65.0119 54.8678 65.1388C48.3573 65.2657 46.8018 59.3888 46.8018 59.3888Z",
    fill: "#E16070"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3623 71.3629C43.3623 71.3629 45.2129 68.9521 46.1046 68.705C46.1046 68.705 45.1861 71.0357 43.3623 71.3629Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8145 59.676C47.8145 59.676 49.4303 60.5442 53.6679 60.9449C57.9054 61.3456 61.6334 59.5424 61.6334 59.5424C61.6334 59.5424 54.7273 61.3656 47.8145 59.676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2821 61.7462C29.2821 61.7462 29.852 62.6678 32.5273 62.808C35.2026 62.9483 37.442 61.3655 37.442 61.3655C37.442 61.3655 35.3434 62.4474 32.8223 62.3673C30.3012 62.2871 29.2754 61.7529 29.2754 61.7529L29.2821 61.7462Z",
    fill: "white"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4873 11.1583C45.4873 11.1583 53.2986 9.69576 65.3876 11.4254C65.3876 11.4254 57.5361 10.5239 45.4873 11.1583Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3229 89.5879C62.4178 92.3461 61.5595 96.1527 61.5595 96.1527C68.1505 97.8222 74.8353 97.3013 74.8353 97.3013C74.6409 95.585 73.4005 94.63 73.4005 94.63C71.1074 93.8687 67.5269 90.7299 67.4331 89.6347C67.299 88.0386 72.2875 74.4015 64.0873 71.5366L60.1582 72.4782C61.298 73.1126 61.7339 73.4799 62.5116 74.1745C68.8344 79.8176 64.1476 87.0435 63.3229 89.5946V89.5879Z",
    fill: "url(#paint40_linear_627_2408)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5527 96.1527C68.1437 97.8222 74.8285 97.2947 74.8285 97.2947C74.6408 95.585 73.3937 94.63 73.3937 94.63C71.1006 93.8687 67.5201 90.7299 67.4263 89.6347C67.3391 88.653 68.3985 86.4558 68.7472 81.5206C68.7472 81.5206 67.1178 81.9814 65.7366 81.8879C65.2338 85.3405 63.7117 88.3925 63.3228 89.5879C62.4177 92.346 61.5594 96.1527 61.5594 96.1527H61.5527Z",
    fill: "url(#paint41_linear_627_2408)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5527 96.1526V97.3748C61.5527 97.3748 67.3525 99.0443 74.8285 97.869V97.3013C74.8285 97.3013 67.8152 97.7287 61.5527 96.1593V96.1526Z",
    fill: "url(#paint42_linear_627_2408)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4005 94.63C73.4005 94.63 68.6601 94.5499 65.5088 92.1925L67.4331 89.6347C67.4331 89.6347 68.8076 92.6934 73.4005 94.63Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1514 72.4781C61.2912 73.1126 62.2969 74.0275 63.0814 74.722C63.4502 73.1326 65.864 72.4648 65.864 72.4648C65.2203 71.817 64.0805 71.5432 64.0805 71.5432L60.1514 72.4848V72.4781Z",
    fill: "#5E364C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.381 59.4956C77.3762 59.2285 77.2891 54.8342 77.2891 54.8342C77.8456 52.1161 79.3274 53.4718 79.3274 53.4718C79.3274 53.4718 77.5036 58.0264 79.381 59.5023V59.4956Z",
    fill: "#5E364C"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4678 64.2773C38.4678 64.2773 39.2925 65.5462 40.8145 66.2808C41.9342 66.8217 44.8308 65.9068 46.3595 64.4242L47.1306 63.5961L38.4678 64.2773Z",
    fill: "url(#paint43_linear_627_2408)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_627_2408",
    x1: 34.042,
    y1: 97.3748,
    x2: 34.042,
    y2: 71.3629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#46255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_627_2408",
    x1: 33.0901,
    y1: 97.3748,
    x2: 33.0901,
    y2: 81.5206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_627_2408",
    x1: 26.4521,
    y1: 97.2212,
    x2: 39.728,
    y2: 97.2212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#731653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_627_2408",
    x1: 10.501,
    y1: 38.0851,
    x2: 10.501,
    y2: 15.3656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_627_2408",
    x1: 20.1243,
    y1: 35.7549,
    x2: 5.69786,
    y2: 14.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_627_2408",
    x1: 21.4271,
    y1: 34.0049,
    x2: 8.05718,
    y2: 14.3418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46185E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68466D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_627_2408",
    x1: 15.1144,
    y1: 38.6327,
    x2: 15.1144,
    y2: 6.73062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_627_2408",
    x1: 25.0917,
    y1: 36.9776,
    x2: 11.3162,
    y2: 5.86986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_627_2408",
    x1: 20.2704,
    y1: 36.2686,
    x2: 20.2704,
    y2: 5.18127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56305C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_627_2408",
    x1: 63.1621,
    y1: 27.7338,
    x2: 61.0333,
    y2: 8.49851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9EADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCCBD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_627_2408",
    x1: 33.0162,
    y1: 59.5023,
    x2: 33.0162,
    y2: 19.1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46255E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684A72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_627_2408",
    x1: 57.3288,
    y1: 21.9971,
    x2: 57.3288,
    y2: 12.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9A5992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2B0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_627_2408",
    x1: 24.8563,
    y1: 18.8049,
    x2: 24.8563,
    y2: 11.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_627_2408",
    x1: 27.605,
    y1: 23.66,
    x2: 27.605,
    y2: 11.7527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_627_2408",
    x1: 30.8573,
    y1: 36.2285,
    x2: 27.5898,
    y2: 23.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCEA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFA892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_627_2408",
    x1: 62.4107,
    y1: 75.5302,
    x2: 56.2107,
    y2: 19.4807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF9F9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB2B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_627_2408",
    x1: 51.0729,
    y1: 46.1591,
    x2: 51.0729,
    y2: 31.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_627_2408",
    x1: 31.6287,
    y1: 47.9757,
    x2: 31.6287,
    y2: 35.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_627_2408",
    x1: 31.2191,
    y1: 42.3993,
    x2: 31.2191,
    y2: 37.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_627_2408",
    x1: 75.2102,
    y1: 37.6777,
    x2: 75.2102,
    y2: 27.8073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_627_2408",
    x1: 45.8563,
    y1: 26.9724,
    x2: 45.8563,
    y2: 19.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_627_2408",
    x1: 50.275,
    y1: 37.6777,
    x2: 50.275,
    y2: 32.7024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ECB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F6DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FCF6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_627_2408",
    x1: 58.8107,
    y1: 75.0093,
    x2: 58.8107,
    y2: 46.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_627_2408",
    x1: 54.3651,
    y1: 64.8783,
    x2: 54.3651,
    y2: 51.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FAC8CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_627_2408",
    x1: 33.197,
    y1: 65.1388,
    x2: 33.197,
    y2: 53.5052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FAC8CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_627_2408",
    x1: 57.5293,
    y1: 68.7784,
    x2: 91.7246,
    y2: 68.7784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B44263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#EF5666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_627_2408",
    x1: 40.452,
    y1: 71.7369,
    x2: 42.9744,
    y2: 62.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#DF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD0C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_627_2408",
    x1: 44.4076,
    y1: 69.9739,
    x2: 42.0644,
    y2: 62.7291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#731653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_627_2408",
    x1: 84.8523,
    y1: 59.5023,
    x2: 84.8523,
    y2: 19.1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46255E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684A72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_627_2408",
    x1: 93.0125,
    y1: 18.8049,
    x2: 93.0125,
    y2: 11.9196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_627_2408",
    x1: 90.3705,
    y1: 23.66,
    x2: 90.3705,
    y2: 11.7527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_627_2408",
    x1: 87.011,
    y1: 36.2285,
    x2: 90.2785,
    y2: 23.0729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCEA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FFA892"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_627_2408",
    x1: 100.126,
    y1: 40.4775,
    x2: 110.871,
    y2: 3.09875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_627_2408",
    x1: 103.681,
    y1: 41.7379,
    x2: 114.488,
    y2: 4.14724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_627_2408",
    x1: 106.25,
    y1: 42.101,
    x2: 116.732,
    y2: 5.64029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56305C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_627_2408",
    x1: 108.598,
    y1: 37.9197,
    x2: 116.728,
    y2: 9.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_627_2408",
    x1: 111.698,
    y1: 38.8992,
    x2: 119.843,
    y2: 10.5666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7D4A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A896AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_627_2408",
    x1: 114.219,
    y1: 38.7557,
    x2: 121.767,
    y2: 12.5033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56305C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_627_2408",
    x1: 118.814,
    y1: 29.3165,
    x2: 118.075,
    y2: 22.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9EADEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCCBD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_627_2408",
    x1: 118.419,
    y1: 29.3623,
    x2: 120.278,
    y2: 22.8971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#C1DAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_627_2408",
    x1: 67.4934,
    y1: 97.3748,
    x2: 67.4934,
    y2: 71.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#684A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#46255E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_627_2408",
    x1: 68.1906,
    y1: -17.7854,
    x2: 68.1906,
    y2: 81.5206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCEA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_627_2408",
    x1: 74.8285,
    y1: -17.7851,
    x2: 61.5527,
    y2: -17.7851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A1A43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#731653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_627_2408",
    x1: 38.4678,
    y1: 65.0119,
    x2: 47.1306,
    y2: 65.0119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FAC8CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/strength.b6ce8ec9260c67cd014bd9bea40bc80f.svg";
export { ForwardRef as ReactComponent };